import { readLocalStorage, writeLocalStorage } from "./localStoragePreference.ts";

export type Theme = "light" | "dark";

const LOCAL_STORAGE_KEY = "swmm-theme";

// window.matchMedia can throw/be absent (e.g. some test/SSR environments) —
// same defensive spirit as readLocalStorage's own try/catch above.
function prefersDarkColorScheme(): boolean {
  try {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  } catch {
    return false;
  }
}

/** Same first-visit spirit as `readSavedLanguage` honouring the browser's own language: nothing saved yet -> the OS's own `prefers-color-scheme`, not a hardcoded "light". */
export function readSavedTheme(): Theme {
  const saved = readLocalStorage(LOCAL_STORAGE_KEY);
  if (saved === "dark" || saved === "light") return saved;
  return prefersDarkColorScheme() ? "dark" : "light";
}

export function saveTheme(theme: Theme): void {
  writeLocalStorage(LOCAL_STORAGE_KEY, theme);
}
